import { Dispatch, SetStateAction, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { TimeStamp } from "./context/shared";
import { toast } from "react-toastify";
import { centerClient } from "../../shared/clients";
import type { AccountMessage as AccountMessageDto } from "../../shared/generated";

const SECONDS_IN_1_HOUR = 3600;

export class AccountMessage {
    Login: string;
    Kind: string;
    Message: string;
    Period: TimeStamp;
    LastSend: TimeStamp;
    constructor(data?) {
        this.Login = data?.Login;
        this.Kind = data?.Kind;
        this.Message = data?.Message;
        this.Period = new TimeStamp(data?.Period);
        this.LastSend = new TimeStamp(data?.LastSend);
    }
}
interface IAccountMessageDialogProps {
    login?: string;
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    data: AccountMessage | null;
    setData: Dispatch<SetStateAction<AccountMessage>>;
}

export const AccountMessageDialog = (props: IAccountMessageDialogProps) => {
    const { login, show, setShow, data, setData } = props;
    const successSet = (res?: { Success?: boolean; Description?: string }) => {
        if (res?.Success) {
            handleClose();
            toast.success("Сообщение для аккаунта сохранено!", { autoClose: 1500 });
        }
        else {
            handleClose();
            toast.error(res?.Description);
        }
    }
    useEffect(() => {
        if(login)
            getAccountMessage();

    }, [login])
    const successGet = (data) => {
        setData(new AccountMessage(data));
    }
    const getAccountMessage = () => {
        if (!login)
            return;

        centerClient.getAccountMessage(login)
            .then((res) => {
                const data = res.data;
                if (data)
                    successGet(data);
            })
            .catch(() => void 0);
    }
    const errorSet = () => {
        handleClose();
    }
    const handleChangeProperty = (data) => {
        centerClient.setAccountMessage(data as AccountMessageDto)
            .then((res) => successSet(res.data))
            .catch(() => errorSet());
    }
    const handleClose = () => {
        setShow(false);
    }
    const saveComment = () => {
        handleChangeProperty(data);
    }
    const setPeriod = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!data)
            return;
        const checked = e.target.checked;
        setData({ ...data, Period: checked ? new TimeStamp({ Seconds: SECONDS_IN_1_HOUR, Nanos: 0 }) : new TimeStamp({ Seconds: 0, Nanos: 0 }) })
    }
    return (
        data &&
        <Modal id="editMessageContainer" show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Сообщение для {login}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Label>Сообщение</Form.Label>
                <Form.Control maxLength={4096} value={data?.Message} onChange={(e) => setData({ ...data, Message: e.target.value })} as="textarea" rows={3 } />
                <div style={{ display: 'flex', marginTop: '.5rem' }}>
                    <Form.Label title="Вкл/Откл отправки сообщения по запросу">Отправка</Form.Label>
                    <Form.Check id="forPeriod" style={{ marginLeft: '1rem' }} color="secondary" checked={data?.Period.Seconds && data.Period.Seconds > 0 ? true : false} onChange={(e) => setPeriod(e)} />
                </div>
                <div style={{ display: 'flex', marginTop: '.5rem' }}>
                    <Form.Label title="Время последней отсылки сообщения">Последняя отправка: </Form.Label>
                    <label style={{ marginLeft: '1rem' }}>{data?.LastSend && data.LastSend.Seconds && data.LastSend.Seconds !== 0 ? data.LastSend.toDateString() : <></>}</label>
                </div>                
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={saveComment} variant="custom">
                    Сохранить
                </Button >
                <Button variant="custom" onClick={handleClose}>Закрыть</Button>
            </Modal.Footer>
        </Modal>    
    )
}